export interface ModalOutputData<T = null> {
  continue: boolean;
  outputData?: T;
}
